import { createReducer, on } from '@ngrx/store';
import { ForwarderActions } from './forwarder.actions';
import { Forwarder, ForwarderCreateResponse } from '../../../shared/interfaces/forwarder.interfaces';

export const forwarderFeatureKey = 'forwarder';

export interface ForwarderState {
  forwarders?: Forwarder[] | [] | undefined;
  forwarderDetails?: Forwarder | {} | undefined;
  forwarderResponse?: ForwarderCreateResponse | undefined;
}

export const initialState: ForwarderState = {
};

export const forwarderReducer = createReducer(
  initialState,

  on(ForwarderActions.loadForwardersSuccess, (state, action) => { return { ...state, forwarders: action.data } }),

  on(ForwarderActions.loadForwarderDetailsSuccess, (state, action) => { return { ...state, forwarderDetails: action.data } }),

  on(ForwarderActions.createForwarderSuccess, (state, action) => { return { ...state, forwarderResponse: action.data } }),

  on(ForwarderActions.unsetForwarderStore, () => initialState)

);
